import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'vtcTitle'
})
export class VtcTitlePipe implements PipeTransform {

  transform(value: string): string {
    return value.substr(0, value.indexOf('/'));
  }

}
